<template>
  <ul class="nav nav-tab mb-5">
    <li class="nav-item ml-0 pl-0" :class="{active: tab=='google'}">
      <router-link :to="'/marketing'" class="nav-link" >
        Google Merchant
      </router-link>
    </li>
    <li class="nav-item" :class="{active: tab=='facebook'}">
      <router-link :to="'/marketing/facebook'" class="nav-link" >
        Facebook Cactalog
      </router-link>
    </li>
    <li class="nav-item" :class="{active: tab=='amazon'}">
      <router-link class="nav-link"  :to="'/marketing/amazon'">
        Amazon
      </router-link>
    </li>
  </ul>
</template>

<script>
    export default {
        name: "NavMarketing",
        props: [
            'tab'
        ]
    }
</script>

<style scoped lang="scss">

</style>